import { View, ButtonView } from '@ckeditor/ckeditor5-ui/src';

//import '../../theme/charactergrid.css';

class ImageButton extends ButtonView {
    constructor( locale, srcUri ) {
		super( locale );

        const bind = this.bindTemplate;

        this.setTemplate( {
			tag: 'span',
			children: [
				{
					tag: 'img',
					attributes: {
						class: [
							'ck',
							'ck-character-grid__tile_img'
						],
                        src: (srcUri ? srcUri : "")
					},
					children: this.tiles
				}
			],
			attributes: {
				class: [
					'ck',
					'ck-character-grid__tile'
				]
			},
            on: {
				click: bind.to( evt => {
					if ( this.isEnabled ) {
						this.fire( 'execute' );
					} else {
						evt.preventDefault();
					}
				} )
			}
		}); 
    }
}

export default class CharacterGridView extends View {

	constructor( locale ) {
		super( locale );

		this.tiles = this.createCollection();

		this.setTemplate( {
			tag: 'div',
			children: [
				{
					tag: 'div',
					attributes: {
						class: [
							'ck',
							'ck-character-grid__tiles'
						]
					},
					children: this.tiles
				}
			],
			attributes: {
				class: [
					'ck',
					'ck-character-grid'
				]
			}
		} );
	}

	createTile( imgUri, name ) {
		const tile = new ImageButton( this.locale, imgUri );

		tile.set( {
			//label: character,
			withText: false,
            tooltip: true,
			class: 'ck-character-grid__tile ck-emoji-grid-font-size',
		} );

		// Labels are vital for the users to understand what character they're looking at.
		// For now we're using native title attribute for that, see #5817.
		tile.extendTemplate( {
			attributes: {
				title: name,
                // style: `background-image: url('${character}');  
                //     background-repeat: no-repeat;
                //     background-size: auto;` 
			},
			on: {
				mouseover: tile.bindTemplate.to( 'mouseover' )
			}
		} );

		tile.on( 'mouseover', () => {
			this.fire( 'tileHover', { name, imgUri } );
		} );

		tile.on( 'execute', () => {
			this.fire( 'execute', { name, imgUri } );
		} );

		return tile;
	}
}